"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _warning = _interopRequireDefault(require("../_util/warning"));
var _dropdown = _interopRequireDefault(require("../rc-components/dropdown"));
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Dropdown, _Component);
  var _super = (0, _createSuper2["default"])(Dropdown);
  function Dropdown() {
    var _this;
    (0, _classCallCheck2["default"])(this, Dropdown);
    _this = _super.apply(this, arguments);
    _this.renderOverlay = function () {
      var overlay = _this.props.overlay;
      var overlayElements = typeof overlay === 'function' ? overlay() : overlay;
      if (overlayElements) {
        var overlayElement = _react.Children.only(overlayElements);
        var overlayProps = overlayElement.props;
        (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly

        var _overlayProps$selecta = overlayProps.selectable,
          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
          _overlayProps$focusab = overlayProps.focusable,
          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
        return typeof overlayElement.type === 'string' ? overlayElement : /*#__PURE__*/(0, _react.cloneElement)(overlayElement, {
          mode: 'vertical',
          selectable: selectable,
          focusable: focusable
        });
      }
    };
    return _this;
  }
  (0, _createClass2["default"])(Dropdown, [{
    key: "getTransitionName",
    value: function getTransitionName() {
      var _this$props = this.props,
        _this$props$placement = _this$props.placement,
        placement = _this$props$placement === void 0 ? '' : _this$props$placement,
        transitionName = _this$props.transitionName;
      if (transitionName !== undefined) {
        return transitionName;
      }
      if (placement.indexOf('top') >= 0) {
        return 'slide-down';
      }
      return 'slide-up';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        customizePrefixCls = _this$props2.prefixCls,
        trigger = _this$props2.trigger,
        disabled = _this$props2.disabled;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
      var child = _react.Children.only(children);
      var dropdownTrigger = /*#__PURE__*/(0, _react.cloneElement)(child, {
        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
        disabled: disabled
      });
      var triggerActions = disabled ? [] : trigger;
      var alignPoint;
      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
      }
      return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], (0, _extends2["default"])({
        alignPoint: alignPoint
      }, this.props, {
        prefixCls: prefixCls,
        transitionName: this.getTransitionName(),
        trigger: triggerActions,
        overlay: this.renderOverlay
      }), dropdownTrigger);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return _ConfigContext["default"];
    }
  }]);
  return Dropdown;
}(_react.Component);
exports["default"] = Dropdown;
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1,
  placement: 'bottomLeft'
};